import { useLocation } from "@opendash/router";

export function usePath() {
  return useLocation().pathname;
}
